import { lazy } from 'react';

export const PrintableReceipt = lazy(() =>
  import('./PrintableReceipt').then((m) => ({ default: m.PrintableReceipt })),
);
export const PrintableVisitStatement = lazy(() =>
  import('./PrintableVisitStatement').then((m) => ({
    default: m.PrintableVisitStatement,
  })),
);
export const PrintableInvoice = lazy(() =>
  import('./PrintableInvoice').then((m) => ({ default: m.PrintableInvoice })),
);
export const PrintableExpense = lazy(() =>
  import('./PrintableExpense').then((m) => ({ default: m.PrintableExpense })),
);
export const PrintablePrescription = lazy(() =>
  import('./PrintablePrescription').then((m) => ({
    default: m.PrintablePrescription,
  })),
);

export const PrintableTreatmentPlanStatement = lazy(() =>
  import('./PrintableTreatmentPlanStatement').then((m) => ({
    default: m.PrintableTreatmentPlanStatement,
  })),
);

export const PrintablePatientCard = lazy(() =>
  import('./PrintablePatientCard').then((m) => ({
    default: m.PrintablePatientCard,
  })),
);

export const PrintablePlanAcceptance = lazy(() =>
  import('./PrintablePlanAcceptance').then((m) => ({
    default: m.PrintablePlanAcceptance,
  })),
);

export const PrintableConsent = lazy(() =>
  import('./PrintableConsent').then((m) => ({ default: m.PrintableConsent })),
);

export const PrintablePayslip = lazy(() =>
  import('./PrintablePayslip').then((m) => ({ default: m.PrintablePayslip })),
);
